import { Link } from "react-router-dom";
import { Seo } from "../lib/seo";
import { MaskText, Reveal, ParallaxImage } from "../lib/motion";
import { SERVICES, IMG } from "../data/site";

export default function ByggRenovering() {
  return (
    <>
      <Seo
        title="Bygg & renovering i Skåne & Göteborg · Casagon"
        description="Casagon hjälper privatpersoner och företag i hela Skåne och hela Göteborg med kök, renovering, dörrar, fönster samt till- och ombyggnation."
        path="/bygg-renovering"
      />

      {/* Hero */}
      <section className="grain relative overflow-hidden bg-graphite pb-16 pt-32 text-warmwhite md:pb-24 md:pt-44" data-testid="bygg-hero">
        <div className="u-container relative z-10 grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="overline text-wood">
                <span className="mr-2 inline-block h-2 w-2 bg-casared align-middle" />
                Bygg & renovering
              </p>
            </Reveal>
            <MaskText
              as="h1"
              animateOnLoad
              delay={0.15}
              lines={["När projektet", "omfattar mer", "än golvet."]}
              className="mt-6 font-display font-bold leading-[0.95] tracking-tight text-[8vw] sm:text-6xl lg:text-7xl"
            />
          </div>
          <div className="flex items-end lg:col-span-4 lg:col-start-9">
            <Reveal delay={0.3}>
              <p className="text-base leading-relaxed text-warmwhite/70">
                Casagon hjälper till med bygg- och renoveringsarbeten för privatpersoner och
                företag i hela Skåne och hela Göteborg.
              </p>
            </Reveal>
          </div>
        </div>
        <div className="u-container relative z-10 mt-14">
          <ParallaxImage src={IMG.darkKitchen} alt="Renoverad, mörk köksmiljö" amount={40} priority className="aspect-[16/9] w-full" />
        </div>
      </section>

      {/* Numbered chapters */}
      <section className="bg-warmwhite py-8 md:py-12" data-testid="bygg-chapters">
        {SERVICES.map((s, i) => (
          <div key={s.n} className="border-b border-graphite/10">
            <div className="u-container grid grid-cols-1 items-stretch gap-0 lg:grid-cols-12">
              <div className={`flex flex-col justify-center py-12 lg:col-span-6 lg:py-16 ${i % 2 === 1 ? "lg:order-2 lg:col-start-7" : ""}`}>
                <Reveal>
                  <span className="font-display text-sm font-bold text-casared">{s.n}</span>
                  <h2 className="mt-4 font-display text-4xl font-bold leading-[0.95] tracking-tight sm:text-5xl lg:text-6xl">
                    {s.title}
                  </h2>
                  <p className="mt-6 max-w-md text-base leading-relaxed text-graphite/70 md:text-lg">{s.desc}</p>
                </Reveal>
              </div>
              <div className={`lg:col-span-5 ${i % 2 === 1 ? "lg:order-1" : "lg:col-start-8"}`}>
                <ParallaxImage src={s.img} alt={s.title} amount={45} className="aspect-[4/3] w-full lg:aspect-auto lg:h-full" />
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* Allservice note */}
      <section className="bg-paper py-14 md:py-16" data-testid="bygg-allservice">
        <div className="u-container grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <MaskText as="h2" lines={["Allservice", "– bredden i", "vardagen."]} className="font-display text-4xl font-bold leading-[0.95] tracking-tight sm:text-5xl" />
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal>
              <p className="text-base leading-relaxed text-graphite/70 md:text-lg">
                Utöver golvläggning och de arbeten vi listar ovan hjälper vi ofta till med det som
                dyker upp längs vägen i ett bygg- eller renoveringsprojekt. Vi utgår från Höör och
                tar uppdrag i hela Skåne och hela Göteborg. Berätta vad du behöver – så säger vi
                ärligt om det är något vi kan lösa.
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-sm leading-relaxed text-graphite/50">
                Många renoveringsarbeten hos privatpersoner kan omfattas av ROT-avdraget. Villkor och
                belopp styrs av Skatteverkets regler.
              </p>
            </Reveal>
            <Reveal delay={0.16}>
              <Link
                to="/kontakt"
                data-testid="bygg-quote-cta"
                className="group mt-9 inline-flex items-center gap-3 bg-graphite px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-warmwhite transition-colors duration-300 hover:bg-casared"
              >
                Begär offert <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
              </Link>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
